import React from 'react';

// A representative slice of the ~140 data-bound select types. They are NOT one control
// each — visually they are all the single-select (Select) or multi-choice control from the
// "Selects & multi-choice" entry; they differ only in which backend list they load on mount.
// Listing one per domain keeps this a reference, not an exhaustive dump. The full set lives
// in src/Enums/InputTypesEnum.js.
const ROWS = [
  { domain: 'User / contact', example: 'ActiveUserSelect', backing: 'Users (active-only filter variant)', renderer: 'renderUserSelect' },
  { domain: 'Client / project', example: 'ClientSelect', backing: 'Clients', renderer: 'renderClientSelect' },
  { domain: 'Service / office', example: 'OfficeSelect', backing: 'Offices', renderer: 'renderOfficeSelect' },
  { domain: 'Currency / country', example: 'CurrencySelect', backing: 'Currencies', renderer: 'renderCurrencySelect' },
  { domain: 'Lookup item (×31)', example: 'IndustryLookupItemSelect', backing: 'LookupItem rows for a fixed lookupId', renderer: 'renderLookupSelect (via lookupSelectConfig.js)' },
  { domain: 'Survey / wave', example: 'SurveySelect', backing: 'Surveys', renderer: 'renderSurveySelect' },
  { domain: 'Third-party', example: 'ThirdPartySourceSelect', backing: 'Tp source systems', renderer: 'renderThirdPartySourceSelect' },
  { domain: 'Status change', example: 'OpportunityStatusChange', backing: 'Allowed status transitions', renderer: 'renderOpportunityStatusChangeSelect' },
  { domain: 'Multi-choice (data-bound)', example: 'ClientMultiChoice', backing: 'Clients (multiple selection)', renderer: 'renderClientMultiChoice' },
];

function InputsDataBoundDemoComponent() {
  return (
    <div>
      <table
        className='table table-sm'
        style={{ maxWidth: 760 }}
      >
        <thead>
          <tr>
            <th>Domain</th>
            <th>Representative type</th>
            <th>Backing data</th>
            <th>Renderer</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((row) => (
            <tr key={row.example}>
              <td>{row.domain}</td>
              <td>
                <code>{row.example}</code>
              </td>
              <td>{row.backing}</td>
              <td>
                <code>{row.renderer}</code>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export const inputsDataBoundDemo = {
  id: 'inputs-databound',
  title: 'Data-bound selects (reference)',
  category: 'Inputs',
  importPath: 'src/Elements/InputComponents/renderers/selectorRenderers.jsx + lookupSelectConfig.js',
  notes: [
    'InputTypesEnum has ~140 data-bound select types beyond the primitives above. Visually they are all the same control — the single-select or multi-choice shown in the “Selects & multi-choice” entry — differing only in which backend list they fetch on mount.',
    'They are catalogued here rather than live-rendered on purpose: each one calls the backend on mount, so mounting them needs a running API and would break the gallery smoke test. This table shows one representative per domain, not all 140.',
    'The 31 “…LookupItemSelect” types are declared as data rows in renderers/lookupSelectConfig.js (each just a lookupId), not as bespoke components.',
    'To add a new data-bound select: add a renderer in selectorRenderers.jsx (or a row in lookupSelectConfig.js) and an InputTypesEnum member — InputWithClear itself needs no change (see the comment at the top of InputWithClear.js).',
  ],
  snippet:
    "// same call shape as any other input — options come from the backend, not props\n<InputWithClear\n  type={InputTypesEnum.ClientSelect}\n  fieldName='ClientId'\n  labelText='Client'\n  value={value}\n  onChange={(fieldName, v) => setValue(v)}\n/>",
  render: InputsDataBoundDemoComponent,
};
